<template>
    <div v-if="errors.length > 0"
         class="modal-errors"
         transition="expand">
        <div v-for="error in errors"
             :key="error"
             class="text-danger">
            {{ error }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                default: function () {
                    return [];
                },
                type: Array
            }
        }
    };
</script>